<div class="row">
  <div class="col-xs-3">
    <ul class="nav nav-pills tabs nav-stacked" role="tablist">
      <li role="presentation" class="tab active">
        <a href="#page_pane" id="page_tab" role="tab" data-toggle="tab">Page Progress</a>
      </li>
      {{#if local}}
      <li role="presentation" class="tab">
        <a href="#survey_pane" id="survey_tab" role="tab" data-toggle="tab">Surveys</a>
      </li>
      <li role="presentation" class="tab">
        <a href="#assessment_pane" id="assessment_tab" role="tab" data-toggle="tab">Assessments</a>
      </li>
      <li role="presentation" class="tab">
        <a href="#action_plan_pane" id="action_plan_tab" role="tab" data-toggle="tab">Action Plan</a>
      </li>
      {{/if}}
    </ul>
  </div>
  <div class="col-xs-9">
    <div class="tab-content">
      <div role="tabpanel" class="tab-pane active" id="page_pane">
        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true"></div>
      </div>
      {{#if local}}
      <div role="tabpanel" class="tab-pane" id="survey_pane"></div>
      <div role="tabpanel" class="tab-pane" id="assessment_pane"></div>
      <div role="tabpanel" class="tab-pane" id="action_plan_pane"></div>
      {{/if}}
    </div>
  </div>
</div>
